import {UmpireArticleLink} from '../umpire-article-link';
import {UmpireCustomLink} from '../umpire-custom-link';
import {UmpireLinkTypeEnum} from '../umpire-link-type';
import {UmpirePageTypeLink} from '../umpire-page-type-link';

export interface UmpireLinkModel {
  type: UmpireLinkTypeEnum;
  url: string;
  name: string;
  data: UmpirePageTypeLink | UmpireArticleLink | UmpireCustomLink | null;
}
